import React from 'react';
import PropTypes from 'prop-types';

import { Box, Title, Text } from '@nerdwallet/currency';

import styles from './boxText.module.less';

const BoxTextTile = ({ title, copy }) => {
  const tileOutput = (
    <div>
      {title && (
        <Title className={styles.boxTextTitle} size="small" component="h2">
          {title}
        </Title>
      )}
      {copy && (
        <div className={styles.boxTextCopy}>
          <Text>{copy}</Text>
        </div>
      )}
    </div>
  );

  return (
    <Box className={styles.boxTextBox} shadow="1" borderRadius="2">
      {tileOutput}
    </Box>
  );
};

BoxTextTile.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
};

BoxTextTile.displayName = 'Box Text Tile';

export default BoxTextTile;
